import LogoComponent from "../../components/Logo";
import React, { useCallback, useMemo, useState } from "react";
import styled from "styled-components";
import { useDispatch, useSelector } from "@/components/resume/redux/hooks";
import resumeSlice from "@/components/resume/redux/services/resumeSlice";
import debounce from "@/utils/debounce";
import moment from "moment";
import Title2 from "./Title"
import Revocation from "@/pages/ResumeDetail/component/Revocation";
import Recover from "@/pages/ResumeDetail/component/Recover";
import FlexStyled from "@/styled/FlexStyled";
import Back from "./component/Back";
import SaveComponent from "./component/SaveComponent";
import Menu from "./Menu";
import { Upload, message } from "antd";
import { modifyResume, uploadResume, uploadResumeAttachment } from "@/http/api";
import { getParam } from "../Mobile/utils";
import {v4} from "uuid";





import resumeDataSlice from "@/components/resume/redux/services/resumeDataSlice";
import getResumePath from "@/common/resume/getResumePath";
import getNestedProperty from "@/utils/getNestedProperty";
import getFieldBySlot from "@/common/module/getFieldBySlot";
import useResumeDetailInstance from "./hooks/useResumeDetailInstance";

const TitleBoxStyled = styled.div`
  position: relative;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  pointer-events: none;
  display: flex;
  align-items: center;
`
const TitleStyled = styled.div`
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #FFFFFF;
  //line-height: 50px;
  opacity: 0.6;
  margin-right: 4px;
  cursor: pointer;
  pointer-events: auto;
  //user-select: none;
`
const TitleIconStyled = styled.div`
  cursor: pointer;
  pointer-events: auto;
`
const TitleInputStyled = styled.input`
  height: 24px;
  pointer-events: auto;
  padding: 0 0.5em;
  outline: none;
  font-size: 14px;
  text-align: left;
  background-color: #fff;
  border: 1px solid #11BBA6;
  width: 230px;
`

const ButtonStyled = styled.div`
  width: 96px;
  height: 30px;
  background: #11BBA6;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;


  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #FFFFFF;
  cursor: pointer;
`

const Button2Styled = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 104px;
    height: 30px;
    border-radius: 4px;
    border: 1px solid #00BCA6;
    background-color: #ffffff;
    font-size: 14px;

    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #11BBA6;
    cursor: pointer;
    &:hover {
        opacity: 0.8;
    }
`

const icon = <div style={{ width: 20, height: 20, position: "relative" }} dangerouslySetInnerHTML={{
    __html: `<svg width="20px" height="20px" viewBox="0 0 20 20" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" style="position: absolute;top: 0">
    <g id="页面-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g id="简历编辑页" transform="translate(-1836.000000, -15.000000)" fill="#FFFFFF" fill-rule="nonzero">
            <g id="编组-6备份" transform="translate(1814.000000, 10.000000)">
                <g id="加协作团队备份-11" transform="translate(22.000000, 5.000000)">
                    <g id="xiazai-15" transform="translate(3.500000, 3.000000)">
                        <path d="M12.3400236,12.6622222 L0.659976387,12.6622222 C0.291617473,12.6622222 0,12.9577778 0,13.3311111 C0,13.7044444 0.291617473,14 0.659976387,14 L12.3400236,14 C12.7083825,14 13,13.7044444 13,13.3311111 C13,12.9733333 12.7083825,12.6622222 12.3400236,12.6622222 Z M6.06257379,11.5111111 C6.18536009,11.6355556 6.35419126,11.6977778 6.50767414,11.6822222 C6.66115702,11.6822222 6.82998819,11.6355556 6.9527745,11.5111111 L10.9433294,7.46666667 C11.1735537,7.23333333 11.1735537,6.84444444 10.9433294,6.61111111 C10.7131051,6.37777778 10.3293979,6.37777778 10.0991736,6.61111111 L7.0755608,9.67555556 L7.0755608,0.606666667 C7.0755608,0.28 6.81463991,0 6.47697757,0 C6.13931523,0 5.87839433,0.264444444 5.87839433,0.606666667 L5.87839433,9.61333333 L2.91617473,6.61111111 C2.68595041,6.37777778 2.30224321,6.37777778 2.07201889,6.61111111 C1.84179457,6.84444444 1.84179457,7.23333333 2.07201889,7.46666667 L6.06257379,11.5111111 Z" id="形状"></path>
                    </g>
                </g>
            </g>
        </g>
    </g>
</svg>`
}} />
const icon2 = <div dangerouslySetInnerHTML={{
    __html: `<svg width="14px" height="14px" viewBox="0 0 14 14" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <g id="简历详情编辑页" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" opacity="0.602698038">
        <g id="简历编辑页备份-4" transform="translate(-706.000000, -18.000000)" fill="#FFFFFF">
            <g id="文本备份-19" transform="translate(706.000000, 17.475000)">
                <rect id="矩形" fill-opacity="0" x="0" y="0.525" width="14" height="14"></rect>
                <g id="自动搜索备份-3" fill-rule="nonzero">
                    <g id="bianji-2" transform="translate(0.702692, 1.752713)">
                        <path d="M12.7588461,10.5162791 L6.10615384,10.5162791 C5.83692307,10.5162791 5.62153846,10.7362274 5.62153846,11.0111628 C5.62153846,11.2860982 5.83692307,11.5060465 6.10615384,11.5060465 L12.8126923,11.5060465 C13.0819231,11.5060465 13.2973077,11.2860982 13.2973077,11.0111628 C13.2434615,10.7912145 13.0280769,10.5162791 12.7588461,10.5162791 Z M0.484615384,11.5472868 L2.79999999,11.5472868 C2.90769231,11.5472868 3.06923077,11.4922997 3.12307692,11.3823256 L11.0923077,3.24423773 C11.3076923,3.02428941 11.3076923,2.74935401 11.0923077,2.52940569 L8.83076922,0.164961236 C8.61538461,-0.0549870788 8.34615383,-0.0549870788 8.13076922,0.164961236 L6.51538461,1.81457364 L0.161538461,8.30304911 C0.0538461486,8.41302327 0,8.52299742 0,8.63297159 L0,10.997416 C0,11.1073902 0.0538461486,11.2723514 0.161538461,11.3823256 C0.21538461,11.4922997 0.376923072,11.5472868 0.484615384,11.5472868 Z M8.45384615,1.20971577 L10.0692308,2.85932817 L9.15384614,3.79410852 L7.53846153,2.14449612 L8.45384615,1.20971577 Z M1.02307692,8.8529199 L6.89230768,2.85932817 L8.50769229,4.50894058 L2.63846153,10.5025323 L1.02307692,10.5025323 L1.02307692,8.8529199 L1.02307692,8.8529199 Z" id="形状"></path>
                    </g>
                </g>
            </g>
        </g>
    </g>
</svg>`
}} />

const icon3 = <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }} dangerouslySetInnerHTML={{
    __html: `
<?xml version="1.0" encoding="UTF-8"?>
<svg width="20px" height="20px" viewBox="0 0 20 20" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>切片</title>
    <g id="小助手" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g id="未展开样式" transform="translate(-1138.000000, -15.000000)" fill="#11BBA6">
            <g id="编组-6备份-2" transform="translate(1128.000000, 10.000000)">
                <g id="加协作团队备份-11" transform="translate(10.000000, 5.000000)">
                    <g id="daoru-4" transform="translate(2.200000, 3.000000)">
                        <path d="M3.18494272,0 C2.83360611,0 2.55100927,0.282596836 2.55100927,0.633933442 L2.55100927,3.18494272 L3.81887616,3.18494272 L3.81887616,1.27550464 L13.3660666,1.27550464 L13.3660666,12.7321331 L3.81887616,12.7321331 L3.81887616,10.822695 L2.54337152,10.822695 L2.54337152,13.3660666 C2.54337152,13.7174032 2.82596836,14 3.17730496,14 L14,14 C14.3513366,14 14.6339334,13.7174032 14.6339334,13.3660666 L14.6339334,0.641571195 C14.6339334,0.290234588 14.3513366,0.00763775232 14,0.00763775232 C14,0 3.18494272,0 3.18494272,0 Z M6.04909984,4.7735952 C5.87343153,4.7735952 5.72831424,4.91871249 5.72831424,5.0943808 L5.72831424,6.36988543 L0.320785597,6.36988543 C0.145117294,6.36988543 0,6.51500273 0,6.69067103 L0,7.32460447 C0,7.50027278 0.145117294,7.64539007 0.320785597,7.64539007 L5.72831424,7.64539007 L5.72831424,8.91325696 L5.73595199,8.96672122 C5.74358974,9.03546099 5.78177851,9.08892526 5.82760502,9.13475177 C5.94980906,9.25695581 6.15602837,9.25695581 6.27823241,9.13475177 L8.18767049,7.22531369 L8.22585925,7.17948718 C8.30987452,7.04964539 8.29459902,6.88161484 8.18767049,6.77468631 L6.27823241,4.86524823 L6.24004364,4.82705947 C6.17894163,4.79650846 6.11020185,4.7735952 6.04909984,4.7735952 Z" id="形状"></path>
                    </g>
                </g>
            </g>
        </g>
    </g>
</svg>
`}} />


const Title = () => {
    const titleVisible = useSelector((state) => !!state.resume);
    const resumeName = useSelector((state) => state.resume?.name);
    const resumeDate = useSelector((state) => state.resume?.updateDate);
    const dispatch = useDispatch();
    const [focus, setFocus] = useState(false);
    const onChange = useCallback(debounce((e) => {
        dispatch(resumeSlice.actions.changeName({ value: e.target.value }));
    }, 500), []);
    const date = useMemo(() => moment(resumeDate).format("YYYY-MM-DD"), [resumeDate])
    return <TitleBoxStyled style={{ visibility: titleVisible ? undefined : "hidden" }}>
        {
            !focus && <>
                <TitleStyled onClick={() => setFocus(true)}>{resumeName}-{date}</TitleStyled>
                <TitleIconStyled onClick={() => setFocus(true)}>{icon2}</TitleIconStyled>
            </>
        }
        {
            focus && <>
                <TitleInputStyled onChange={onChange} autoFocus defaultValue={resumeName}
                    onBlur={() => setFocus(false)} />
            </>
        }
    </TitleBoxStyled>
}

const HeaderContainerStyled = styled.div`
  height: 60px;
  background: #FFFFFF;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 50px;
  padding-left: 8px;
  flex-shrink: 0;
  position: relative;
  z-index: 3;
`

const TitleWrapStyled = styled.div`
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
`


export default (props) => {
    const {
        store,
        onClickDown,
        resumeRef,
        setResumeLoading,
        setLoginVisible,
        setThemeVisible,
        setImportModalVisible,
        setChangeTemplateVisible,
        onClickModule
    } = props;
    const resumeData = useSelector(state => state.resumeData);
    

    const handleUploadVideo = async (file) => {
        const isLt50M = file.size / 1024 / 1024 < 50;
        if (!isLt50M) {
            message.error('单个简历文件最大为50m！');
            return false;
        }
        const requestId = v4()
        const formData = new FormData();
        formData.append('file', file);
        // formData.append('resumeBody', resumeData);
        try {
            setResumeLoading(true);
            await modifyResume({body: {
                id: parseInt(getParam('id')),
                requestId,
                resumeBody: {
                    userData: resumeData
                }
            }})
            const res = await uploadResumeAttachment({
                query: { requestId },
                body: formData
            })
            window.processModifyResume(res)
        } catch (error) {
            console.log('erroer', error)
        } finally {
            setResumeLoading(false)
        }
        return false;
    }

    return <HeaderContainerStyled>
        <FlexStyled $alignItems="center">
            {/* <LogoComponent isDark={false}/> */}
            <Back setLoginVisible={setLoginVisible} />

            <Revocation isDark={true} resumeRef={resumeRef} style={{ margin: "0 10px" }} />
            <Recover isDark={true} resumeRef={resumeRef} />
            <SaveComponent setLoginVisible={setLoginVisible} style={{ marginRight: 16 }} />


        </FlexStyled>
        <TitleWrapStyled style={{ margin: "0 10px" }}><Title2 /></TitleWrapStyled>
        {/* <Menu 
            resumeRef={resumeRef} 
            setThemeVisible={setThemeVisible}
            setImportModalVisible={setImportModalVisible}
            setChangeTemplateVisible={setChangeTemplateVisible}
            onClickModule={onClickModule}/> */}
        {/* <ButtonStyled onClick={onClickDown}>
            <div>{icon}</div>
            下载
        </ButtonStyled> */}
        {/* <Upload
            // accept='video/*'
            beforeUpload={handleUploadVideo}
            showUploadList={false}
            multiple={false}
            className="custom-upload"
        >
            <Button2Styled>
                {icon3}
                导入简历
            </Button2Styled>
        </Upload> */}
        <div />


    </HeaderContainerStyled>
}
